<div class="store-list-panel" [class.bordered]="bordered()" data-id="storeAuthorityStoreList">
  <div
    class="store-list-body"
    [style.grid-template-columns]="'repeat(' + columns() + ', minmax(0, 1fr))'"
    [class.expanded]="expanded()"
    [class.columns-2]="columns() === 2"
    [class.columns-3]="columns() === 3"
    *ngIf="visibleStores().length"
  >
    <span
      class="store-item"
      *ngFor="let store of visibleStores(); index as i"
      [attr.data-id]="'storeAuthorityStoreItem' + i"
    >
      <span class="store-item-content">
        <span class="store-item-no">{{ i + 1 }}</span>
        <span [optionHighlight]="searchTerm()">{{ store.code }} {{ store.name }}</span>
      </span>
    </span>
  </div>

  <div class="store-list-empty" *ngIf="!visibleStores().length && hasSearchTerm()" data-id="noSearchResult">
    <app-no-search-result [totalElements]="0" [hasSearchCriteria]="true"></app-no-search-result>
  </div>

  <div class="store-list-empty" *ngIf="!visibleStores().length && !hasSearchTerm()" data-id="noData">
    <app-no-search-result [totalElements]="0" [hasSearchCriteria]="false"></app-no-search-result>
  </div>

  <a
    *ngIf="canExpand()"
    class="btn-text-link store-list-toggle"
    data-id="storeAuthorityStoreListToggle"
    (click)="toggleExpand()"
  >
    {{ expanded() ? 'View less' : 'View more' }}
  </a>
</div>
